import type { IconType } from 'react-icons';
import {
  FiBook,
  FiBriefcase,
  FiCode,
  FiGlobe,
  FiLayers,
  FiLock,
  FiPenTool,
  FiPieChart,
  FiTrendingUp,
} from 'react-icons/fi';

const SLUG_ICONS: Record<string, IconType> = {
  development: FiCode,
  'data-science': FiPieChart,
  marketing: FiTrendingUp,
  design: FiPenTool,
  business: FiBriefcase,
  'it-software': FiLock,
  'office-productivity': FiBook,
  language: FiGlobe,
  academic: FiBook,
};

export function CategoryIcon({ slug, className = 'size-4 shrink-0' }: { slug: string; className?: string }) {
  const Icon = SLUG_ICONS[slug] ?? FiLayers;
  return <Icon className={className} aria-hidden />;
}
